import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { api } from "@/lib/api";

const PURPLE = [109, 40, 217];
const toDataUrl = async (url) => {
  const r = await api.get(url.replace(/^\/api/, ""), { responseType: "blob" });
  return new Promise((res) => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.readAsDataURL(r.data); });
};

function header(doc, title, u) {
  doc.setFillColor(...PURPLE);
  doc.rect(0, 0, 210, 30, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18); doc.text("SPARKORA EDU", 14, 14);
  doc.setFontSize(11); doc.text(title, 14, 23);
  doc.setTextColor(30, 30, 30);
  doc.setFontSize(10);
  doc.text(`Student: ${u.student_name}${u.admission_number ? ` (${u.admission_number})` : ""}`, 14, 40);
  doc.text(`Class: ${u.class_name} - ${u.section}`, 140, 40);
}

export async function downloadDailyReport(u) {
  const doc = new jsPDF();
  header(doc, "Daily Report Card", u);
  doc.text(`Date: ${u.date}`, 14, 46);
  doc.text(`Teacher: ${u.teacher_name}`, 140, 46);
  const rows = [["Food intake", u.food_intake], ["Nap time", u.nap_time], ["Washroom", u.washroom], ["Classroom activities", u.classroom_activities], ["Learning activities", u.learning_activities],
    ["Behaviour", u.behavior], ["Health observation", u.health_observation], ["Teacher remarks", u.teacher_remarks]].map(([a, b]) => [a, b || "—"]);
  autoTable(doc, { startY: 52, body: rows, theme: "grid", styles: { fontSize: 10, cellPadding: 3 }, columnStyles: { 0: { fontStyle: "bold", cellWidth: 50, fillColor: [245, 240, 255] } } });
  let y = doc.lastAutoTable.finalY + 8;
  const photos = (u.photos || []).slice(0, 4);
  if (photos.length) {
    doc.setFontSize(11); doc.text("Photos", 14, y); y += 4;
    for (let i = 0; i < photos.length; i++) {
      try {
        const data = await toDataUrl(photos[i].url);
        const fmt = data.startsWith("data:image/png") ? "PNG" : data.startsWith("data:image/webp") ? "WEBP" : "JPEG";
        doc.addImage(data, fmt, 14 + (i % 2) * 92, y + Math.floor(i / 2) * 66, 88, 62);
      } catch { /* skip unreadable photo */ }
    }
  }
  doc.save(`daily-report-${u.student_name.replace(/\s+/g, "-")}-${u.date}.pdf`);
}

export function downloadProgressReport(p) {
  const doc = new jsPDF();
  header(doc, `Academic Progress Report • ${p.term} ${p.academic_year}`, p);
  doc.text(`Teacher: ${p.teacher_name}`, 14, 46);
  if (p.attendance_pct != null) doc.text(`Attendance: ${p.attendance_pct}%`, 140, 46);
  autoTable(doc, { startY: 52, head: [["Subject", "Marks", "Grade", "Remarks"]], body: p.subjects.map((s) => [s.subject, s.marks || "—", s.grade || "—", s.remarks || ""]),
    theme: "grid", headStyles: { fillColor: PURPLE }, styles: { fontSize: 10 } });
  const rows = [["Strengths", p.strengths], ["Areas to improve", p.improvements], ["Overall remarks", p.overall_remarks]].filter(([, v]) => v);
  if (rows.length) autoTable(doc, { startY: doc.lastAutoTable.finalY + 6, body: rows, theme: "grid", styles: { fontSize: 10, cellPadding: 3 }, columnStyles: { 0: { fontStyle: "bold", cellWidth: 45, fillColor: [245, 240, 255] } } });
  doc.save(`progress-${p.student_name.replace(/\s+/g, "-")}-${p.term.replace(/\s+/g, "-")}.pdf`);
}
